const css = `@keyframes EYtxaa__fade-in-up{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.EYtxaa__animation{animation-name:EYtxaa__fade-in-up;animation-duration:.5s;animation-fill-mode:both}.EYtxaa__gradient{color:var(--special-intelligence-text-default);background:linear-gradient(90deg,#1f8aff33 25%,#a340f233 75%),#fff}.EYtxaa__purple{background-color:#eae0f5}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"gradient":"EYtxaa__gradient","animation":"EYtxaa__animation","purple":"EYtxaa__purple","fade-in-up":"EYtxaa__fade-in-up"};
